define('Components/AdvantageWidget/js/views/AdvantageWidgetInstanceView',['jquery', 'WidgetInstanceView', 'template!Components/AdvantageWidget/templates/default',

        'template!Components/AdvantageWidget/templates/fidelity',
        'template!Components/AdvantageWidget/templates/icon',
        'template!Components/AdvantageWidget/templates/blocks/discount-line',
    ],
    function ($, WidgetInstanceView, defaultTemplate, fidelityTemplate, iconTemplate, discountLineTemplate) {
        return WidgetInstanceView.extend({
            name: 'AdvantageWidgetInstanceView',
            events: {

                'click .auto-desc-code' : 'autoadddiscount',
            },
            autoadddiscount:function(event)
            {

                var view = this,
                    vouchercode = view.$(event.currentTarget).data('vouchercode');
                app.getCart().addVoucher(vouchercode);
            },
            initialize:function(model){
                //
                var view = this;
                view.subviews = [];
                view.model = model;

                view.setup();
                view.listenToOnce(view.model, 'advantageList', view.preRender);
                view.model.init();
                view.preRender();
            },

            getTemplate: function () {

                switch (this.model.getTemplate()) {
                    case 'fidelity':
                        return fidelityTemplate;
                        break;
                    case 'icon':
                        return iconTemplate;
                        break;
                    case 'default':
                    default:
                        return defaultTemplate;
                        break;
                }
            },

        })
    });
